export default "{{#if( x===1 )}}\n1\n{{elseif (x===2)}}\n2\n{{else}}\n3\n{{/if}}\n\n{{#if ( (x+1) > 2 )}}\n{{/if}}\n"